import React from 'react';
import {Container, Grid2} from '@mui/material';
import SectionTitle from "./SectionTitle";
import ProjectCard from "./ProjectCard";

function Skills() {

    const projects = [
        {
            title: 'WhenItDrop.com',
            description:'Web app that tracks e-commerce prices (with alerting) and offers a blog with top product picks and deals.',
            imgPath: '/images/whenitdrop-logo.svg',
            ctaUrl: 'https://www.whenitdrop.com/',
            skills: [
                'ReactJs',
                'Redux',
                'PhP Symfony + Doctrine',
                'SASS',
                'Amazon/Telegram API',
                'GIT',
                'GitHub Actions',
                'Docker'
            ]
        },
        {
            title: 'ManaMoney.me',
            description:'A minimalist money manager web app that helps you track income and expenses, set budgets, and gain insights with analytics.',
            imgPath: '/images/manamoney-logo.svg',
            ctaUrl: 'https://www.manamoney.me/',
            skills: [
                'ReactJs',
                'React-query + React Context',
                'PhP Symfony + Doctrine',
                'Data Visualization',
                'GIT',
                'GitHub Actions',
                'Docker + Docker-compose',
                '-- Used in previous implementation --',
                'Redux',
                'SASS',
                'LEMP',
            ]
        },
        {
            title: 'CoffeeeCrm',
            description:'Minimal CRM designed for freelancers and small companies',
            imgPath: '/images/coffeeecrm-logo.png',
            ctaUrl: null,
            skills: [
                'ReactJs',
                'Redux',
                'SASS',
                'Firebase (Firestore)',
                'LEMP',
                'GIT',
            ]
        },
        {
            title: 'ToDoDev',
            description:'Automatically sync GitHub projects with Todoist.',
            imgPath: '/images/tododev-logo.png',
            ctaUrl: null,
            skills: [
                'ReactJs',
                'PhP Symfony + Doctrine',
                'SASS',
                'GitHub/Todoist API',
                'LEMP',
                'GIT'
            ]
        },
    ];

    return (
        <Container sx={{ padding: '64px 0',  overflow: 'hidden'}}>
            <SectionTitle title={'Projects'} />
            <Grid2 container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                {projects.map((project, index) => (
                    <Grid2 key={index} size={{ xs: 4, sm: 4, md: 4 }} sx={{display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <ProjectCard {...project}  />
                    </Grid2>
                ))}
            </Grid2>
        </Container>
    );
}

export default Skills;